import React from "react";
import {Form, Button, Alert} from "react-bootstrap";

class CreateBookForm extends React.Component{
    constructor(props) {
      super(props);
    
      this.state = {
        data: {
            "bookId": props.bookId,
            "book_title": "",
            "book_description": "",
            "book_type": "PDF",
            "total_pages": 0,
            "total_chapters": 0
        },

        errors:{},
        isSubmit: "no",
        loading: false
      };
    };
    onchange = event => this.setState({
        data: {...this.state.data, [event.target.name] : event.target.value }
    });
    onSubmit = (e) => {
        e.preventDefault();
        this.props.submit(this.state.data);      
    };
    render(){
        const {book_title, book_description, total_chapters} = this.state.data;
        const {loading} = this.state;
        return(
            <div>
                <Form className="form_comn" onSubmit={this.onSubmit}>
                {this.state.errors.error && (
                    <Alert variant="danger">{this.state.errors.error}</Alert>
                )}
                  <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label>Book Title</Form.Label>
                    <Form.Control 
                        type="text" 
                        placeholder="Write Your Book Name"
                        name="book_title"
                        value = {book_title}
                        onChange={this.onchange}
                        autoComplete="off"
                        required
                    />
                  </Form.Group>
                  <Form.Group controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Book Description</Form.Label>
                    <Form.Control 
                        as="textarea" 
                        name="book_description" 
                        value={book_description} 
                        onChange={this.onchange}
                        required 
                        rows="3" 
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Select Book Type:</Form.Label>
                    <Form.Control as="select" name="book_type" onChange={this.onchange} value="PDF">
                      <option>PDF</option>
                      <option value="PDF">HTML</option>
                    </Form.Control>
                    <Form.Text className="htmlnimp">**HTML Feature is not implemented</Form.Text> 
                  </Form.Group>
                  <div>
                        <label htmlFor="total_chapters">Total Chapters: </label>
                        <input 
                            type="number" 
                            id="total_chapters" 
                            value={total_chapters}
                            className="form_control_c"
                            name="total_chapters"
                            onChange={this.onchange}
                        /><br/>
                    </div><br/>
                  <Button variant="success" className="create_book_btn" type = "submit">Create the Book</Button> 
                </Form>
                {loading && (
                <div className="loader">
                    <div></div>
                    <h1>Please Wait...</h1>
                </div>
                )}
            </div>
        );
    };
};

export default CreateBookForm;